import {BaseObject} from './BaseObject';

export enum PaymentType {
    cash = 'cash',
    invoice = 'invoice',
    free = 'free',
    barter = 'barter'
}

export class PaymentTypeEntity extends BaseObject {

    id: number;
    name: string;
    visibleName: string;

}



// WEBPACK FOOTER //
// /app/src/model/Entities/PaymentType.ts